import { DaoService } from '../../LocalStorage'
import { shoppingCartVar } from '../cache'

export const clearCart = () => {
  shoppingCartVar([])
  DaoService.CartDAO.clearCart()
}
